<template>
    <div>
        <vue-element-loading :active="isLoading" is-full-screen text="Please wait..." />
        <div class="report-box">
            <table>
                <thead>
                    <tr>
                        <td colspan="12">
                            <span style="margin-left:10px;">{{pulseTxt1}}</span>
                            <span style="margin-left:20px;"><button type="button" class="btn btn-outline-secondary btn-sm" @click="prevPage">{{$t("last_wave")}}</button></span>
                            <span style="margin-left:10px;"><button type="button" class="btn btn-outline-secondary btn-sm" @click="nextPage">{{$t("next_wave")}}</button></span>
                            <b-dropdown dropright :text="count_text" variant="outline-secondary" style="margin-left:10px;" size="sm">
                                <b-dropdown-item v-for="(item, index) in pageLength" :key="index" @click="chageCountValue(item)">{{ item }}</b-dropdown-item>
                            </b-dropdown>
                            <!-- <span><button type="button" class="btn btn-outline-secondary btn-sm" @click="downloadRowCSV" style="margin-left:20px;">EXPO</button></span> -->
                        </td>
                    </tr>
                </thead>
                <tr>
                    <td colspan="6">
                        <div>
                            <lineChart
                                :chart-data="lineChartData"
                                class="chart-height"
                            ></lineChart>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>
<script>
import LineChart from '@/components/chart/lineChart.vue';
export default {
    components: {
        LineChart
    },
    data() {
        return {
            type: this.$route.query.type,
            report_id: '',
            db_model: 'db',
            lineChartData: {
                labels: [],
                datasets: []
            },
            data: [],
            pulseTxt1: '第一分波',
            pressureRangeTxt: '',
            pageNow: 1,
            pageLength: 0,
            num: 0,
            count_text: '1',
            isLoading: false,
            // isLoading2: false,
        }
    },
    created(){
        const report = JSON.parse(sessionStorage.getItem('client_report'));
        this.report_id = report.id;
        this.getReport()
    },
    methods: {
        getReport() {
            this.isLoading = true
            const api = `${process.env.VUE_APP_APIPATH}/client/report/rm/data`;
            const json = {
                report_id: this.report_id,
            }
            this.$http.post(api, json).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    this.data = res.data.data
                    this.pageLength = this.data.length
                    this.getFFTReport()
                }
                this.isLoading = false;
            })
        },
        getFFTReport() {
            this.isLoading = true
            const api = `${process.env.VUE_APP_APIPATH}/client/report/rm/single/fft`;
            const json = {
                report_id: this.report_id,
                row_id: this.num
            }
            this.$http.post(api, json).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    // const jsonData = JSON.parse(res.data.data);
                    this.drawPulse(res.data.data);
                }
                this.isLoading = false
            })
        },
        drawPulse(pulse) {
            let pulseAry = [];
            let labAry = [];
            pulseAry = pulse;
            
            pulseAry.splice(0, 1);
            pulse = pulseAry.join(",");
            pulseAry.forEach((item, i) => {
                labAry.push(i);
            })
            
            let result = {
                labels: labAry,
                datasets: [
                {
                    label: 'Single FFT',
                    backgroundColor: "transparent",
                    data: pulseAry,
                    borderColor: "rgba(29, 33, 36, .2)",
                    pointBackgroundColor: "rgba(171, 71, 188, 1)",
                    pointRadius: 1,
                }
                ]
            };
            this.lineChartData = result;
        },
        prevPage() {
            if( this.pageNow > 1 ){
                this.pageNow --;
            }
            this.count_text = this.pageNow;
            this.num = this.pageNow;
            this.pulseTxt1 = "第" + this.num + "分波";
            this.num = this.num - 1
            this.getFFTReport()
        },
        nextPage() {
            if(this.pageNow < this.pageLength){
                this.pageNow ++
            }
            this.count_text = this.pageNow;
            this.num = this.pageNow;
            this.pulseTxt1 = "第" + this.num + "分波";
            this.num = this.num - 1
            this.getFFTReport()
        },
        chageCountValue(index) {
            this.count_text = index;
            this.num = index;
            this.pageNow = index ;
            this.pulseTxt1 = "第" + this.num + "分波";
            this.num = this.num - 1
            this.getFFTReport()
        },
    }
}
</script>